<agm-map [zoom]="mapZoom" [latitude]="latitude" [longitude]="longitude" (mapReady)="mapReadyHandler($event)">

  <agm-marker *ngFor="let device of deviceList" [latitude]="device.latitude" [longitude]="device.longitude"
    [iconUrl]="device.icon" (markerClick)="onMarkerClicked(device)">

    <agm-info-window>
      <b>{{ device.name }}</b><br />
      <ng-container i18n="@@devicesmap_serial">Seriale: </ng-container> {{ device.serial }}<br /><br />
      <a (click)="onInfoWindowClicked(device)" class="button">
        <ng-container i18n="@@devicesmap_details">Dettagli</ng-container> <span>
          <fa-icon icon="search"></fa-icon>
        </span>
      </a>
    </agm-info-window>
  </agm-marker>

</agm-map>
<!-- <app-loading-screen #devicesmaploader></app-loading-screen> -->
